/* eslint-disable import/no-internal-modules */
import { AccountPanelV2 } from "user_site/features/account";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <AccountPanelV2 />
  </WithProviders>
);

export default Component;
